import type { FC } from "react"

import { useTranslation } from "react-i18next"
import { useRecoilValue } from "recoil"
import styled from "styled-components"

import { designRequestNotesState } from "~/containers/Proposal/state/design-request/use-design-request"

const notesDateFormatOptions: Intl.DateTimeFormatOptions = {
  day: `2-digit`,
  month: `2-digit`,
  year: `numeric`,
  hour: `2-digit`,
  minute: `2-digit`,
}

const NotesList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 400px;
`

export const DrawerListItem = styled.li<{ needsInfo?: boolean }>`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border: ${({ needsInfo }) =>
    needsInfo ? `1px solid var(--danger)` : `1px solid #cecece`};
  padding: 25px;

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: var(--grey-dark);
  }
`

export const Notes: FC = () => {
  const { t } = useTranslation()
  const designRequestNotes = useRecoilValue(designRequestNotesState)

  return (
    <>
      <h3>{t(`notes`)}</h3>
      <NotesList>
        {designRequestNotes.length ? (
          designRequestNotes.map((note) => {
            const noteDate = new Date(note.createdAt)
            const needsInfo = note.reason === `needs info`

            return (
              <DrawerListItem key={note.id} needsInfo={needsInfo}>
                <p>{note.message}</p>
                {note.reason && (
                  <p>
                    Revision reason(s):{` `} {note?.reason}
                  </p>
                )}
                <p style={{ color: `#333333`, lineHeight: `17px` }}>
                  {noteDate
                    .toLocaleDateString(`en-US`, notesDateFormatOptions)
                    .replace(`,`, ` `)}
                </p>
              </DrawerListItem>
            )
          })
        ) : (
          <DrawerListItem key="noNotes">
            <p>{t(`thereAreNoNotesForThisDesign`)}</p>
          </DrawerListItem>
        )}
      </NotesList>
    </>
  )
}
